// eslint-disable-next-line import/no-cycle
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CHECKBOX_VALUES } from '../../pricing-simulator/types/generic-table.model';

interface IScenarioManagerTopBarState {
  // Use to store the value of the checkboxes that are selected.
  activeCheckboxValues: CHECKBOX_VALUES[];
  // Store the value of the search input box.
  searchInputVal: string;
}

const initialState: IScenarioManagerTopBarState = {
  activeCheckboxValues: [CHECKBOX_VALUES.IS_ACTIVE_FINALIZED],
  searchInputVal: ''
};

const scenarioManagerTopBarSlice = createSlice({
  name: 'scenario-manager-top-bar',
  initialState,
  reducers: {
    /**
     * Computing if the checkbox selection has been changed
     *  It will store the value in ${activeCheckboxValues}
     */
    handleCheckboxValueChange(
      state,
      action: PayloadAction<{
        name: CHECKBOX_VALUES;
        checked: boolean;
      }>
    ) {
      const { name, checked } = action.payload;
      if (checked) {
        state.activeCheckboxValues.push(name);
      } else {
        state.activeCheckboxValues.splice(
          state.activeCheckboxValues.findIndex((val) => val === name),
          1
        );
      }
    },
    /**
     * Handler for search  bar
     */
    handleSearchInputValueChange(
      state,
      action: PayloadAction<{
        inputVal: string;
      }>
    ) {
      state.searchInputVal = action.payload.inputVal;
    }
  },
  extraReducers: (builder) => builder
});

export const { handleCheckboxValueChange, handleSearchInputValueChange } =
  scenarioManagerTopBarSlice.actions;

export {};

export default scenarioManagerTopBarSlice;
